import { useState } from 'react';

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9p1poiftmtnfcfh0g20';

const NewsletterSection = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setStatus('submitting');

    try {
      const res = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          email: formData.get('email') as string,
        }).toString(),
      });

      const responseText = await res.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，我们会定期为您推送最新的韩国漫画推荐。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后重试';
        setStatus('error');
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600">
          <i className="ri-mail-send-line text-2xl md:text-3xl"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
          订阅韩漫推荐
        </h2>
        <p className="mt-3 text-sm text-foreground-600 max-w-md mx-auto leading-relaxed">
          第一时间获取最新韩国漫画推荐、热门排行和独家漫评，不错过任何一部好作品
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="mt-8 flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="请输入您的邮箱"
            className="flex-1 px-4 py-3 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent transition-all"
          />
          <button
            type="submit"
            disabled={status === 'submitting'}
            className="px-6 py-3 rounded-lg bg-primary-500 text-background-50 dark:text-foreground-950 font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer disabled:opacity-50"
          >
            {status === 'submitting' ? '提交中...' : '立即订阅'}
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-accent-600">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-red-500">{message}</p>
        )}

        <p className="mt-4 text-xs text-foreground-400">
          我们尊重您的隐私，绝不会发送垃圾邮件
        </p>
      </div>
    </section>
  );
};

export default NewsletterSection;